<template>
  <a-card :bordered="false">
    <a-table :columns="columns" :pagination="false" :data-source="dataSource" :loading="loading" @change="onTableChange">
    </a-table>
  </a-card>
</template>

<script>
import { tableListMixin } from "@/mixins";
import { workExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "公司名称", dataIndex: "companyName", key: "companyName" },
  { title: '职位名称', dataIndex: "jobTitleName", key: "jobTitleName" },
  { title: '入职时间', dataIndex: "timeEntry", key: "timeEntry" },
  { title: '离职时间', dataIndex: "timeDeparture", key: "timeDeparture" },
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: {
  },
  data() {
    return {
      dateFormat,
      columns,
      queryParam: {},
      listUrl: workExpriseInfo.pageList,
      listKeyField: "id",
    }
  },
}
</script>

<style scoped></style>
